<template>
  <v-container fluid class="personal-info px-2 px-md-0">
    <v-form ref="userForm" @submit.prevent="updateUserAddress">
      <v-row class="personal-info-content mb-5">
        <div class="d-block d-md-flex justify-space-between col-12 px-0">
          <h2 class="mb-1 mb-md-3 w-md-50 w-100 py-0 pl-0 group-label flex">
            Basic Information
          </h2>
          <!-- <div class="text-right w-md-50">
            <v-btn
              small
              color="appGreen"
              class="white--text"
              @click="showInviteModal = true"
            >
              Invite new members
              <v-icon small class="ml-2">mdi-send</v-icon>
            </v-btn>
          </div> -->
          <!-- verif -->

                    
         
        </div>
        <v-col cols="12">
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field
                flat
                outlined
                hide-details="auto"
                v-model="user.firstName"
                :rules="userRules.firstName"
                label="First Name"
                disabled="true"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="user.lastName"
                :rules="userRules.lastName"
                label="Last Name"
                hide-details="auto"
                disabled="true"
                flat
                outlined
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="user.email"
                :rules="userRules.email"
                label="Email Address"
                hide-details="auto"
                flat
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-autocomplete
                v-model="user.position.id"
                :rules="userRules.userPositionId"
                label="Position"
                :items="userPositions"
                item-text="name"
                item-value="id"
                hide-details="auto"
                flat
                outlined
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="user.gdcNumber"
                :rules="userRules.gdcNumber"
                type="number"
                label="GDC Number"
                hide-details="auto"
                disabled="true"
                flat
                outlined
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
 <!-- <v-row class="personal-info-content">
        <div class="d-block d-md-flex justify-space-between w-100 align-center">
          <h2 class="group-label flex">Addresses</h2>
          <div class="text-right text-md-center">
            <a href="#" @click="add"> Add Address </a>
          </div>
        </div>
        <v-col cols="12">
          <v-row>
            <v-col class="py-0 d-flex justify-space-between">
              <div class="mt-8 flex">
                <div
                  v-for="address in addresses"
                  :key="address.id"
                  class="mt-3 mt-md-0"
                >
                  <div
                    class="d-block d-md-flex align-center justify-space-between"
                  >
                    <div class="flex font-15 w-70">
                      {{ address | formattedAddress }}
                    </div>
                    <div class="text-right">
                      <v-chip
                        class="ma-2 mr-4 white--text"
                        small
                        :color="
                          address.approved == 1
                            ? '#23A0A0'
                            : address.approved == 2
                            ? '#FF7777'
                            : '#C03737'
                        "
                      >
                        {{
                          address.approved == 1
                            ? "Approved"
                            : address.approved == 2
                            ? "Pending"
                            : "Unapproved"
                        }}
                      </v-chip>

                      <v-btn icon small @click="openEditModal(address)">
                        <v-icon>
                          mdi-pencil
                        </v-icon>
                      </v-btn>
                      <v-btn icon small @click="destroy(address)">
                        <v-icon>
                          mdi-delete
                        </v-icon>
                      </v-btn>
                    </div>
                  </div>
                  <v-divider class="d-block d-md-none"></v-divider>
                </div>
              </div>
              <v-radio-group @change="changeActive" :value="active" class="mt-0">
              <template v-for="address in addresses">
                <v-radio
                  :key="address.id"
                  :label="address.label"
                  :value="address.id"
                  v-if="address.label !== ''"
                ></v-radio>
              </template>
            </v-radio-group> 
            </v-col>
          </v-row> 
          <template v-for="(address, index) in addresses">
            <v-form
              :key="address.id"
              :ref="index + '-form'"
              @submit.prevent="save(address, index)"
            >
              <v-row
                class="flex-wrap company-info-content"
                :key="address.id"
                v-if="address.active"
              >
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="address.address"
                    :rules="addressRules"
                    label="Address"
                    solo
                    dense
                    hide-details="auto"
                    flat
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-text-field
                    v-model="address.city"
                    :rules="cityRules"
                    label="City"
                    solo
                    flat
                    dense
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-text-field
                    v-model="address.postcode"
                    :rules="postcodeRules"
                    label="Postcode"
                    solo
                    dense
                    hide-details="auto"
                    flat
                  ></v-text-field>
                </v-col>
                <v-col sm="6" md="6">
                  <v-select
                    v-model="address.countryId"
                    :items="countries"
                    :rules="countryRules"
                    label="Country"
                    solo
                    flat
                    dense
                    value
                    item-text="name"
                    item-value="id"
                    hide-details="auto"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="address.aptNo"
                    :rules="aptNoRules"
                    label="Building No"
                    solo
                    dense
                    hide-details="auto"
                    flat
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field
                    v-model="address.state"
                    :rules="stateRules"
                    label="State"
                    solo
                    dense
                    hide-details="auto"
                    flat
                  ></v-text-field>
                </v-col>
                <v-col sm="6" class="d-block d-md-none"></v-col>
              </v-row>
              <v-btn
                v-if="address.active"
                class="mr-2"
                :key="address.id"
                color="#23A0A0"
                dark
                type="submit"
                >Save</v-btn
              >
            </v-form>
          </template>
        </v-col>
      </v-row> -->
      <v-dialog v-model="showAddModal" width="800">
        <v-form ref="addressCreateForm" @submit.prevent="createAddress">
          <v-card>
            <v-card-title>
              <span class="headline ml-3">Create Address</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      v-model="address.address"
                      :rules="addressRules"
                      label="Address"
                      solo
                      dense
                      hide-details="auto"
                      flat
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    <v-text-field
                      v-model="address.city"
                      :rules="cityRules"
                      label="City"
                      solo
                      flat
                      dense
                      hide-details="auto"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    <v-text-field
                      v-model="address.postcode"
                      :rules="postcodeRules"
                      label="Postcode"
                      solo
                      dense
                      hide-details="auto"
                      flat
                    ></v-text-field>
                  </v-col>
                  <v-col sm="6" md="6" @click.stop>
                    <v-select
                      v-model="address.countryId"
                      :items="countries"
                      :rules="countryRules"
                      label="Country"
                      solo
                      flat
                      dense
                      value
                      item-text="name"
                      item-value="id"
                      hide-details="auto"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      v-model="address.aptNo"
                      :rules="aptNoRules"
                      label="Building No"
                      solo
                      dense
                      hide-details="auto"
                      flat
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      v-model="address.state"
                      :rules="stateRules"
                      label="State"
                      solo
                      dense
                      hide-details="auto"
                      flat
                    ></v-text-field>
                  </v-col>
                  <v-col sm="6" class="d-block d-md-none"></v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn v-if="appr" color="appGreen darken-1" dark type="submit" disabled>
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
      <v-dialog v-model="showEditModal" width="800">
        <v-form ref="addressEditForm" @submit.prevent="editAddress">
          <v-card>
            <v-card-title>
              <span class="headline ml-3">Update Address</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      v-model="address.address"
                      :rules="addressRules"
                      label="Address"
                      solo
                      dense
                      hide-details="auto"
                      flat
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    <v-text-field
                      v-model="address.city"
                      :rules="cityRules"
                      label="City"
                      solo
                      flat
                      dense
                      hide-details="auto"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    <v-text-field
                      v-model="address.postcode"
                      :rules="postcodeRules"
                      label="Postcode"
                      solo
                      dense
                      hide-details="auto"
                      flat
                    ></v-text-field>
                  </v-col>
                  <v-col sm="6" md="6" @click.stop>
                    <v-select
                      v-model="address.countryId"
                      :items="countries"
                      :rules="countryRules"
                      label="Country"
                      solo
                      flat
                      dense
                      value
                      item-text="name"
                      item-value="id"
                      hide-details="auto"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      v-model="address.aptNo"
                      :rules="aptNoRules"
                      label="Building No"
                      solo
                      dense
                      hide-details="auto"
                      flat
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      v-model="address.state"
                      :rules="stateRules"
                      label="State"
                      solo
                      dense
                      hide-details="auto"
                      flat
                    ></v-text-field>
                  </v-col>
                  <v-col sm="6" class="d-block d-md-none"></v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="appGreen darken-1" dark type="submit">
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
      <div class="mt-5 d-flex justify-end ">
        <v-btn
          :disabled="approvedStatus"
          :block="$vuetify.breakpoint.mobile"
          color="appRed"
          type="submit"
          class="white--text d-block d-md-inline-block"
          >Save</v-btn
        >
      </div>
    </v-form>
  </v-container>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "PersonalInfoComponent",
  filters: {
    formattedAddress: function(address) {
      let formatted = `${address.aptNo} ${address.address}, ${address.city}, ${address.postcode}, ${address.country.name}`;
      return formatted.length > 75
        ? `${formatted.substring(0, 75)}...`
        : formatted;
    }
  },
  mounted() {
    
    this.$store.dispatch("user/GET_USER");
    this.$store.dispatch("user/GET_USER_POSITIONS");
    this.$store.dispatch("user/GET_USER_ADDRESSES");
    this.$store.dispatch("country/GET_COUNTRIES");

   
  
  
  },
  methods: {
    async updateUserAddress() {
      if (this.$refs.userForm.validate()) {
        this.$swal({
          title: "Updating personal ...",
          html: "this may only take a moment...",
          icon: "info",
          onOpen: () => {
            this.$swal.showLoading();
          }
        });
        this.user.gdcNumber = parseInt(this.user.gdcNumber, 10);
        await this.$store.dispatch("user/UPDATE_USER_ADDRESS", this.user);
        this.$swal({
          title: "Success",
          html: "Your personal info has been updated",
          icon: "info"
        });
      }
    },
    async destroy(address) {
      let { value } = await this.$swal.fire({
        title: "Delete address",
        html: "Are you sure you want to delete this address",
        allowEscapeKey: false,
        allowOutsideClick: false,
        confirmButtonText: "Yes",
        showCancelButton: true,
        cancelButtonText: "No"
      });
      if (value) {
        this.$swal({
          title: "Deleting address ...",
          html: "this may only take a moment...",
          icon: "info",
          onOpen: () => {
            this.$swal.showLoading();
          }
        });
        await this.$store.dispatch("user/DELETE_ADDRESS", address);
        this.$swal({
          title: "Success",
          html: "Address has been deleted",
          icon: "info"
        });
        return true;
      }
      return false;
    },
    async editAddress() {
      if (this.$refs.addressEditForm.validate()) {
        this.showEditModal = false;
        this.$swal({
          title: "Updating address",
          html: "This will only take a moment",
          icon: "info",
          onOpen: () => {
            this.$swal.showLoading();
          }
        });
        await this.$store.dispatch("user/UPDATE_ADDRESS", this.address);
        this.$swal.close();
        this.$swal({
          title: "Success",
          html: "Address updated successfully",
          icon: "info"
        });
        this.$refs.addressCreateForm.resetValidation();
      }
    },
    async createAddress() {
      if (this.$refs.addressCreateForm.validate()) {
        this.showAddModal = false;
        this.$swal({
          title: "Creating address",
          html: "This will only take a moment",
          icon: "info",
          onOpen: () => {
            this.$swal.showLoading();
          }
        });
        await this.$store.dispatch("user/CREATE_ADDRESS", this.address);
        this.$swal.close();
        this.$swal({
          title: "Success",
          html: "Address created successfully",
          icon: "info"
        });
        this.$refs.addressCreateForm.resetValidation();
      }
    },
    openEditModal(address) {
      this.$store.commit("user/LOAD_ADDRESS", address);
      this.showEditModal = true;
    },
    async save(address, index) {
      if (this.$refs[index + "-form"][0].validate()) {
        this.$swal({
          title:
            address.id === undefined
              ? "Creating address..."
              : "Updating address",
          html: "this will only take a moment...",
          icon: "info",
          onOpen: () => {
            this.$swal.showLoading();
          }
        });
        await this.$store.dispatch("user/SAVE_ADDRESS", address);
        this.$swal.close();
        this.$swal({
          title: "Success",
          html:
            address.id !== undefined
              ? "Address updated successfully"
              : "Address created successfully",
          icon: "info"
        });
      }
    },
    add() {
      this.showAddModal = true;
    },
    changeActive(id) {
      this.$store.commit("user/CHANGE_ACTIVE", id);
      this.$forceUpdate();
    }
  },
  computed: {
    ...mapState({
      jwt: state => state.auth.user,
      user: state => state.user.user,
      userPositions: state => state.user.userPositions,
      active: state => state.user.active,
      addresses: state => state.user.addresses,
      countries: state => state.country.countries,
      address: state => state.user.address,
      
    }),
    approvedStatus() {
      return this.user.approved ? true : false;
    }
  },
  data: () => ({
    showAddModal: false,
    showEditModal: false,
    userRules: {
      firstName: [
        v => !!v || "First Name is required",
        v => (v && v.length >= 3) || "First Name must be at least 3 characters",
        v =>
          (v && v.length <= 35) ||
          "First Name must be less than than 35 characters"
      ],
      lastName: [
        v => !!v || "First Name is required",
        v => (v && v.length >= 3) || "First Name must be at least 3 characters",
        v =>
          (v && v.length <= 35) ||
          "First Name must be less than than 35 characters"
      ],
      email: [
        v => !!v || "E-mail is required",
        v => /.+@.+\..+/.test(v) || "E-mail must be valid"
      ],
      userPositionId: [v => !!v || "User Position is required"],
      gdcNumber: [
        v => !!v || "GDC Number is required",
        v => (v && v >= 10000000) || "GDC Number must be at least 8 digits",
        v =>
          (v && v <= 1000000000) ||
          "GDC Number must be less than than 10 digits"
      ]
    },
    addressRules: [
      v => !!v || "Address is required",
      v => (v && v.length >= 4) || "Address must be at least 4 characters",
      v =>
        (v && v.length <= 100) ||
        "Address must be less than than 100 characters"
    ],
    cityRules: [
      v => !!v || "City is required",
      v => (v && v.length >= 3) || "City must be at least 3 characters",
      v => (v && v.length <= 35) || "City must be less than than 35 characters"
    ],
    postcodeRules: [
      v => !!v || "Postcode is required",
      v => (v && v.length >= 3) || "Postcode must be at least 3 characters",
      v =>
        (v && v.length <= 10) || "Postcode must be less than than 10 characters"
    ],
    countryRules: [v => !!v || "Country is required"],
    aptNoRules: [v => !!v || "Apt no is required"],
    stateRules: [
      v => !!v || "State is required",
      v => (v && v.length >= 3) || "State must be at least 3 characters",
      v => (v && v.length <= 25) || "State must be less than than 25 characters"
    ]
  })
};
</script>
<style lang="scss" src="./PersonalInfo.scss"></style>
<style lang="scss">
.personal-info {
  .v-input {
    .v-label,
    input {
      font-size: 14px;
    }
  }
  .vue-tel-input-vuetify .v-text-field--solo-flat .v-input__slot .v-label {
    top: 10px;
  }
  .vue-tel-input-vuetify .v-text-field--solo-flat .v-input__slot .v-label {
    top: 17px;
    left: 11px !important;
  }
  .country-code .v-input__slot .v-input__append-inner {
    margin-top: 15px !important;
  }
}
</style>
